import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
// import Popper from '@mui/material/Popper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import {
	OPEN_CLOSE_ADD_GROUP_MODAL,
	ADD_GROUP_RESET_SUCCESS_MSG_OR_ERROR,
	GROUP_ADD_TRIGGER,
	SHOW_GROUP_MODAL,
	// SITE_ADDED_SUCCESS_MSG,
} from '../../constants/groupConstants';
// import Fade from '@mui/material/Fade';
// import Paper from '@mui/material/Paper';
// import { Close } from '../../assets/icons/index';
import CustomTextField from '../../components/customTextField/CustomTextField';
// import CustomSelectField from '../../components/customSelectField/CustomSelectField';
// import CustomSelectFieldCountry from '../customSelectField/customSelectFieldCountry';
// import CustomTreeSelectField from '../customTreeSelectField/CustomTreeSelectField';
import CustomCheckbox from '../../components/checkbox/Checkbox';
import './AddGroup.scss';
import useTheme from '../../hooks/useTheme';
// import Button from '../../components/buttons/Button';
import Tooltip from '../../components/tooltip/Tooltip';
import {
	addGroup,
	listGroupBySite,
	groupCountrylistBySite,
	listGroup,
} from '../../actions/groupActions';
import Toast from '../../components/toast/Toast';
import PropTypes from 'prop-types';
import FormModal from '../formModal/FormModal';
// import TopologySelect from '../topology/TopologySelect';
// import OpenWifiLogo from '../../assets/openwifi_logo.png';
import {
	listCountryCodes,
	listLiteTopology,
	// listGroup,
	// listGroupHomeAdd,
} from '../../actions/groupActions';
import {
	// DescriptionTT,
	// GroupNameTT,
	LocationTT,
	ParentSiteTT,
	RegulatoryDomainCountryTT,
	RootGroupCBTT,
	TIPGroupCBTT,
} from '../../constants/tooltipConstants';
import { getSystemConfig } from '../../actions/licenseManagement/licenseActions.js';
import { getErrorMsgFromApiResp } from '../../utils/utility';
import { OpenWiFiSiteIcon } from '../../assets/icons/index';
import CustomSelectField from '../customSelectField/CustomSelectField.jsx';
import TopologySelectWOLazyLoading from '../topology/TopologySelectWOLazyLoading.jsx';
import { API_SUCCESS_CODES } from '../../constants/commonConstants.js';
import { getGroupInfo } from '../../actions/groupConfigurationActions/groupConfigurationActions.js';
import { decryptData } from '../../utils/crypto';
import Alert from '../Alerts/Alert.jsx';
let systemConfigFetched = false;

/**
 * Renders a topology add group component
 * @return {JSX.Element} The JSX element representing the topology add group.
 */
const AddGroup = ({ onAdd, selectedNode, tableLoc }) => {
	
	const { color, FontFace } = useTheme('LIGHT');
	const subtitleFont = {
		color: color.text.primary,
		fontFamily: 'Inter-Medium',
		fontSize: FontFace.font_size.input_text,
	};
	const calledOnceCountryCode = useRef(false);
	// const isAddGroupOpen = useSelector(
	// 	(state) => state.groupList?.isAddGroupModalOpen
	// );
	// console.log("isAddGroupOpen12", isAddGroupOpen);

	const dispatch = useDispatch();
	const groupList = useSelector((state) => state.groupListHomeAdd);
	const [hideTooltip, setHideTooltip] = useState(false);
	const addGroupReducer = useSelector((state) => state.addGroup);
	const { isAddGroupModalOpen } = groupList;
	const { addGroupSource } = useSelector((state) => state.groupList);
	const {
		dataStatus: data,
		msg: addSuccessMessage,
		error: addErrorMessage,
	} = addGroupReducer;
	const [groupName, setGroupName] = React.useState('');
	const [sapId, setSapId] = React.useState('');
	const [location, setLocation] = React.useState('');
	const [country, setCountry] = React.useState('');
	const [parentGroup, setParentGroup] = React.useState([]);
	const [description, setDescription] = React.useState('');
	const [descriptionError, setDescriptionError] = React.useState('');
	const [groupNameError, setGroupNameError] = React.useState('');
	const [locationError, setLocationError] = React.useState('');
	const [countryError, setCountryError] = React.useState('');
	const [parentGroupError, setParentGroupError] = React.useState('');
	const [rootGroupCheckbox, setRootGroupCheckbox] = React.useState(false);
	const [tipGroupCheckbox, setTipGroupCheckbox] = React.useState(false);
	const [parentGroupName, setParentGroupName] = React.useState([]);
	const [groupValue, setGroupValue] = useState('');
	const [sapIdError, setSapIdError] = useState('');
	const [toastMessage, setToastMessage] = useState('');
	const [toastType, setToastType] = useState('');
	const [showToast, setShowToast] = useState('');
	const [regionValue, setRegionValue] = useState([]);
	const [sapLabel, setSapLabel] = useState('SAP ID');
	const [onSaveCalled, setOnSaveCalled] = useState(false);
	// const [sapValue, setSapValue] = useState();
	const { groupListBySite } = useSelector((state) => state.groupCountryList);

	const [isSaveDisabled, setIsSaveDisabled] = useState(true);
	const [siteData, setSiteData] = useState({});
	const [showMaxSiteAlert, setShowMaxSiteAlert] = useState(false);

	useEffect(() => {
		if (isAddGroupModalOpen) {
			const getSiteData = async () => {
				if (systemConfigFetched) return;
				systemConfigFetched = true;
				
				const storedSelected = JSON.parse(
					decryptData(localStorage.getItem('selectedNode')) || '{}'
				);
				const selected = selectedNode || storedSelected;

				if (addGroupSource !== 'sidebar' && selected?.site_id) {
					const resp = await dispatch(getGroupInfo(selected.site_id));
					setSiteData(resp?.data);
				}
			};

			getSiteData();
		}
	}, [selectedNode?.site_id, isAddGroupModalOpen]);

	useEffect(() => {
		if (siteData?.is_tip_enabled === 1) {
			setTipGroupCheckbox(true);
		}
	}, [siteData]);
const fetchSystemConfig = async () => {
		if (systemConfigFetched) return;
		systemConfigFetched = true;

		try {
			const systemConfig = await dispatch(getSystemConfig());

			if (systemConfig?.[0]?.country) {
				setCountry(systemConfig[0].country);
				setCountryError('');
			}

			if (
				systemConfig?.[0]?.sap_id_label === 1 &&
				systemConfig?.[0]?.custom_sap_id_label
			) {
				setSapLabel(systemConfig[0].custom_sap_id_label);
			}
		} catch (error) {
			console.error('Error fetching system config:', error);
		}
	}
	useEffect(() => {
	if (isAddGroupModalOpen) {
		fetchSystemConfig();
	}
}, [dispatch, isAddGroupModalOpen]);


	const initialStateRef = React.useRef(null); // Start as null and initialize later

	useEffect(() => {
		// Initialize ref with current values only once (on mount)
		if (!initialStateRef.current) {
			initialStateRef.current = {
				groupName,
				sapId,
				location,
				description,
				rootGroupCheckbox,
				tipGroupCheckbox,
				parentGroupName: parentGroup?.site_name || null,
				// groupValue,
			};
		}
	}, []); // Run only once on mount

	// Function to check if state has changed
	const checkIfStateChanged = () => {
		const currentState = {
			groupName,
			sapId,
			location,

			description,
			rootGroupCheckbox,
			tipGroupCheckbox,
			parentGroupName,
			// groupValue
		};

		let hasChanges = false;

		Object.keys(initialStateRef.current).forEach((key) => {
			const initialValue = initialStateRef.current[key];
			const currentValue = currentState[key];

			const isEquivalent =
				(Array.isArray(initialValue) &&
					initialValue.length === 0 &&
					currentValue === null) ||
				(Array.isArray(currentValue) &&
					currentValue.length === 0 &&
					initialValue === null);

			const initialStr = isEquivalent
				? 'null or []'
				: JSON.stringify(initialValue);
			const currentStr = isEquivalent
				? 'null or []'
				: JSON.stringify(currentValue);

			if (!isEquivalent && initialStr !== currentStr) {
				hasChanges = true;
			}
		});
		// Update isSaveDisabled (disable if no changes)
		setIsSaveDisabled(!hasChanges);
	};
	useEffect(() => {
		if (isAddGroupModalOpen && addGroupSource !== 'sidebar') {
			// Use selectedNode prop if available, otherwise fall back to localStorage
			const storedSelected = JSON.parse(
				decryptData(localStorage.getItem('selectedNode')) || '{}'
			);
			const selected = selectedNode || storedSelected;
			setParentGroup({
				site_id: selected?.site_id,
				site_name: selected?.site_name,
			});
			setGroupValue({
				site_id: selected?.site_id,
				site_name: selected?.site_name || selected?.nested_site_name,
				nested_site_name: selected?.nested_site_name,
			});
			if (selected?.country) {
				setCountry(selected?.country?.code ?? selected?.country);
			}
		}
	}, [isAddGroupModalOpen]);


	// Run check when dependencies change
	useEffect(() => {
		checkIfStateChanged();
	}, [
		groupName,
		sapId,
		location,
		description,
		rootGroupCheckbox,
		tipGroupCheckbox,
		parentGroupName,
		groupValue,
	]);

	useEffect(() => {
		if (isAddGroupModalOpen) {
			dispatch(listGroup());
		}
		// dispatch(listGroup());
	}, [dispatch, isAddGroupModalOpen]);

	// useEffect(() => {
	// 	if (selectedNode) {
	// 		setGroupValue({
	// 			site_id: selectedNode?.site_id,
	// 			nested_site_name: selectedNode?.nested_site_name,
	// 		});
	// 		setParentGroup({
	// 			site_id: selectedNode?.site_id,
	// 			site_name:
	// 				selectedNode?.site_name || selectedNode?.nested_site_name,
	// 			nested_site_name: selectedNode?.nested_site_name,
	// 		});
	// 		setParentGroupError('');
	// 	}
	// }, [selectedNode]);

	useEffect(() => {
		const fetchCountryCodes = async () => {
			try {
				if (calledOnceCountryCode.current) return;
				calledOnceCountryCode.current = true;
				const groupResponse = await dispatch(listCountryCodes());
				// Transform the data into the format required by CustomSelectField
				const countries = Object.keys(groupResponse.data).map(
					(code) => ({
						value: code,
						label: groupResponse.data[code],
					})
				);

				setRegionValue(countries);
			} catch (error) {
				console.error('Failed to fetch country codes:', error);
			}
		};
		if (isAddGroupModalOpen) {
			fetchCountryCodes();
		}
	}, [dispatch, isAddGroupModalOpen]);

	const handleGroupName = (e) => {
		let value = e.target.value;
		value = value.replace(/\s/g, '');
		setGroupName(value);

		let errorMessage = '';

		if (!value) {
			errorMessage = '';
		} else if (value.length < 3 || value.length > 50) {
			errorMessage = 'Site Name must be between 3 and 50 characters long';
		}

		setGroupNameError(errorMessage);
	};
	const handleSapId = (e) => {
		setSapId(e.target.value);
		const value = e.target.value;
		if (!value) {
			setSapIdError('');
			return;
		} else if (value.trim().length < 2 || value.trim().length > 20) {
			setSapIdError('SAP ID must be between 2 and 20 characters.');
			return;
		} else if (!validateSapId(value.trim())) {
			setSapIdError('SAP ID cannot contain special characters.');
			return;
		}
		setSapIdError('');
	};
	const handleLocation = (e) => {
		const value = e.target.value.trim();
		setLocation(value);
		setLocationError('');

		if (!value) {
			setLocationError('');
		} else if (
			value.length < 2 ||
			value.length > 100 ||
			!validateLocation(value)
		) {
			setLocationError('Location must be between 2 and 100 characters');
		}
	};

	const handleCountry = (e) => {
		setCountry(e.target.value);
		setCountryError('');
	};


	useEffect(() => {
		// Check if parentGroup or modal state has changed
		if (parentGroup && parentGroup.parent_id) {
			dispatch(groupCountrylistBySite(parentGroup.parent_id)); // Call the API with parent_id
		}
	}, [dispatch, parentGroup, isAddGroupModalOpen]);

	const handleParentGroup = (e) => {
		setParentGroup(e);
		if (e?.site_name) {
			setParentGroupName([e?.site_name]);
		} else {
			setParentGroupName([]);
		}
		setParentGroupError('');
	};

	useEffect(() => {
		if (groupListBySite && parentGroup) {
			// Find matching group and set country
			const selectedGroup = groupListBySite.find(
				(item) => item.site_name === parentGroup.site_name
			);
			if (selectedGroup && selectedGroup.country) {
				setCountry(selectedGroup.country);
			} else {
				setCountry('');
			}
		}
	}, [groupListBySite]);

	const handleDescription = (e) => {
		const value = e.target.value.trim();
		setDescription(value);
		setDescriptionError('');

		if (!value) {
			setDescriptionError('');
		} else if (value.length < 4 || value.length > 255) {
			setDescriptionError(
				'Description must be between 4 and 255 characters long.'
			);
		}
	};

	const onReset = () => {
		setHideTooltip(false);
		setParentGroupName([]);
		setGroupName('');
		setSapId('');
		setLocation('');
		setCountry('');
		setParentGroup(null);
		setDescription('');
		setGroupValue('');
		setRootGroupCheckbox(false);
		setTipGroupCheckbox(false);
		setGroupNameError('');
		setLocationError('');
		setParentGroupError('');
		setSapIdError('');
		setDescriptionError('');
		setShowMaxSiteAlert(false);
	};
	const onClose = () => {
		onReset();
		closeModal(false);
	};
	const validateGroupName = (input) => {
		const regex = /^[^\s]{3,50}$/;
		return regex.test(input);
	};
	const validateLocation = (input) => {
		const regex = /^.{2,50}$/;
		return regex.test(input);
	};
	const validateSapId = (input) => {
		const regex = /^[a-zA-Z0-9]+$/;
		return regex.test(input);
	};
	const onSave = () => {
		if (rootGroupCheckbox && !tipGroupCheckbox) {
			if (
				groupName.trim().length === 0 ||
				!validateGroupName(groupName.trim())
			) {
				setGroupNameError(
					'Site Name is required and must be between 3 and 50 characters'
				);
			} else if (
				location.trim().length === 0 ||
				!validateLocation(location.trim())
			) {
				setLocationError(
					'Location is required and must be between 2 and 100 characters'
				);
			} else if (!(country?.code ?? country)?.trim()) {
				setCountryError('Please Select Country');
			} else if (sapId.trim().length === 0) {
				setSapIdError(`${sapLabel} is required.`);
				return;
			} else if (sapId.trim().length < 2 || sapId.trim().length > 20) {
				setSapIdError(
					`${sapLabel} must be between 2 and 20 characters.`
				);
				return;
			} else if (!validateSapId(sapId.trim())) {
				setSapIdError(`${sapLabel} cannot contain special characters.`);
				return;
			} else if (description && description.trim().length < 4) {
				setDescriptionError(
					'Description must be between 4 and 255 characters long.'
				);
				return;
			} else {
				// call add group api
				setOnSaveCalled(true);
				dispatch(
					addGroup({
						parentSite: 0,
						is_tip_enabled: 0,
						is_eoip_ap_group: false,
						site_name: groupName,
						sap_id: sapId,
						site_location: location,
						description: description,
						country: country?.code ?? country,
						use_separate_tunnel: 0,
					})
				);
				// dispatch({ type: OPEN_CLOSE_ADD_GROUP_MODAL, payload: false });
				// dispatch(listGroup());
			}
		}
		if (tipGroupCheckbox && !rootGroupCheckbox) {
			if (parentGroup && Object.keys(parentGroup).length === 0) {
				setParentGroupError('Please Select Parent Site');
			} else if (!parentGroup) {
				setParentGroupError('Please Select Parent Site');
			} else if (
				groupName.trim().length === 0 ||
				!validateGroupName(groupName.trim())
			) {
				setGroupNameError(
					'Site Name is required and must be between 3 and 50 characters'
				);
			} else if (
				location.trim().length === 0 ||
				!validateLocation(location.trim())
			) {
				setLocationError(
					'Location is required and must be between 2 and 100 characters'
				);
			} else if (sapId.trim().length === 0) {
				setSapIdError(`${sapLabel} is required.`);
				return;
			} else if (sapId.trim().length < 2 || sapId.trim().length > 20) {
				setSapIdError(
					`${sapLabel} must be between 2 and 20 characters.`
				);
				return;
			} else if (!validateSapId(sapId.trim())) {
				setSapIdError(`${sapLabel} cannot contain special characters.`);
				return;
			} else if (description && description.trim().length < 4) {
				setDescriptionError(
					'Description must be between 4 and 255 characters long.'
				);
				return;
			} else {
				setOnSaveCalled(true);

				// call add group api

				dispatch(
					addGroup({
						parentSite: {
							siteName: parentGroup?.site_name,
							parent_id: parentGroup.parent_id,
							site_id: parentGroup.site_id,
						},
						is_tip_enabled: tipGroupCheckbox ? 1 : 0,
						is_eoip_ap_group: false,
						site_name: groupName,
						sap_id: sapId,
						site_location: location,
						description: description,
						use_separate_tunnel: 0,
					})
				);
				// dispatch({ type: OPEN_CLOSE_ADD_GROUP_MODAL, payload: false });
				// dispatch({
				// 	type: SHOW_GROUP_MODAL,
				// 	payload: { displayGroupModal: false, modalLoc: tableLoc },
				// });
			}
		}
		if (rootGroupCheckbox && tipGroupCheckbox) {
			if (
				groupName.trim().length === 0 ||
				!validateGroupName(groupName.trim())
			) {
				setGroupNameError(
					'Site Name is required and must be between 3 and 50 characters'
				);
			} else if (
				location.trim().length === 0 ||
				!validateLocation(location.trim())
			) {
				setLocationError(
					'Location is required and must be between 2 and 100 characters'
				);
			} else if (sapId.trim().length === 0) {
				setSapIdError('SAP ID is required.');
				return;
			} else if (sapId.trim().length < 2 || sapId.trim().length > 20) {
				setSapIdError('SAP ID must be between 2 and 20 characters.');
				return;
			} else if (!validateSapId(sapId.trim())) {
				setSapIdError('SAP ID cannot contain special characters.');
				return;
			} else if (description && description.trim().length < 4) {
				setDescriptionError(
					'Description must be between 4 and 255 characters long.'
				);
				return;
			} else {
				setOnSaveCalled(true);

				// call add group api
				dispatch(
					addGroup({
						parentSite: 0,
						is_tip_enabled: tipGroupCheckbox ? 1 : 0,
						is_eoip_ap_group: false,
						site_name: groupName,
						sap_id: sapId,
						site_location: location,
						description: description,
						use_separate_tunnel: 0,
					})
				);
				// dispatch({ type: OPEN_CLOSE_ADD_GROUP_MODAL, payload: false });
				// dispatch({
				// 	type: SHOW_GROUP_MODAL,
				// 	payload: { displayGroupModal: false, modalLoc: tableLoc },
				// });
			}
		}
		if (!tipGroupCheckbox && !rootGroupCheckbox) {
			if (parentGroup && Object.keys(parentGroup).length === 0) {
				setParentGroupError('Please Select Parent Site');
			} else if (!parentGroup) {
				setParentGroupError('Please Select Parent Site');
			} else if (
				groupName.trim().length === 0 ||
				!validateGroupName(groupName.trim())
			) {
				setGroupNameError(
					'Site Name is required and must be between 3 and 50 characters'
				);
			} else if (
				location.trim().length === 0 ||
				!validateLocation(location.trim())
			) {
				setLocationError(
					'Location is required and must be between 2 and 100 characters'
				);
			
			} else if (!(country?.code ?? country)?.trim()) {
				setCountryError('Please Select Country');
			} else if (sapId.trim().length === 0) {
				setSapIdError(`${sapLabel} is required.`);
				return;
			} else if (sapId.trim().length < 2 || sapId.trim().length > 20) {
				setSapIdError(
					`${sapLabel} must be between 2 and 20 characters.`
				);
				return;
			} else if (!validateSapId(sapId.trim())) {
				setSapIdError(`${sapLabel} cannot contain special characters.`);
				return;
			} else if (description && description.trim().length < 4) {
				setDescriptionError(
					'Description must be between 4 and 255 characters long.'
				);
				return;
			} else {
				// call add group api
				setOnSaveCalled(true);

				dispatch(
					addGroup({
						parentSite: {
							siteName: parentGroup.site_name,
							parent_id: parentGroup.parent_id || '',
							site_id: parentGroup.site_id,
						},
						is_tip_enabled: 0,
						use_separate_tunnel: 0,
						is_eoip_ap_group: false,
						site_name: groupName,
						sap_id: sapId,
						site_location: location,
						description: description,
						country: country,
					})
				);
				// dispatch({ type: OPEN_CLOSE_ADD_GROUP_MODAL, payload: false });
				// dispatch({
				// 	type: SHOW_GROUP_MODAL,
				// 	payload: { displayGroupModal: false, modalLoc: tableLoc },
				// });
			}
		}
	};
	const onCancel = () => {
		setHideTooltip(false);
		setParentGroupName([]);
		setGroupName('');
		setSapId('');
		setLocation('');
		setCountry('');
		setParentGroup(null);
		setDescription('');
		setGroupValue('');
		setRootGroupCheckbox(false);
		setTipGroupCheckbox(false);
		setGroupNameError('');
		setLocationError('');
		setParentGroupError('');
		setSapIdError('');
		setDescriptionError('');
		setShowMaxSiteAlert(false);
		dispatch({ type: OPEN_CLOSE_ADD_GROUP_MODAL, payload: false });
		dispatch({
			type: SHOW_GROUP_MODAL,
			payload: { displayGroupModal: false, modalLoc: tableLoc },
		});
		dispatch({ type: 'SET_ADD_GROUP_SOURCE', payload: null });
	};

	const onCancelToast = () => {
		dispatch({
			type: ADD_GROUP_RESET_SUCCESS_MSG_OR_ERROR,
			payload: {
				msg: null,
				error: null,
			},
		});
		setShowToast(false);
	};

	const updateTipGroupCheckBox = (value) => {
		setTipGroupCheckbox(value);
		setGroupName('');
		setSapId('');
		setLocation('');
		setCountry('');
	};
	const updateRootGroupCheckBox = (value) => {
		setRootGroupCheckbox(value);
		setGroupName('');
		setSapId('');
		setLocation('');
		setCountry(country);
		if (value) {
			setParentGroup(null);
		} else {
			// if disabling Root Site -> restore previously selected parent from groupValue
			if (groupValue && groupValue.site_id) {
				setParentGroup({
					site_id: groupValue.site_id,
					site_name: groupValue.site_name || groupValue.nested_site_name,
				});
				setParentGroupName([groupValue.site_name || groupValue.nested_site_name]);
			}
		}
	};
	// const regionValue = [
	// 	{
	// 		value: 'IN',
	// 		label: 'India',
	// 	},
	// 	{
	// 		value: 'AF',
	// 		label: 'Africa',
	// 	},
	// 	{
	// 		value: 'EU',
	// 		label: 'Europe',
	// 	},
	// 	{
	// 		value: 'NAR',
	// 		label: 'North America',
	// 	},
	// ];
	const closeModal = (val) => {
		onReset();
		dispatch({ type: OPEN_CLOSE_ADD_GROUP_MODAL, payload: val });
		dispatch({ type: GROUP_ADD_TRIGGER, payload: false });
		dispatch({
			type: SHOW_GROUP_MODAL,
			payload: { displayGroupModal: false, modalLoc: tableLoc },
		});
		dispatch({ type: 'SET_ADD_GROUP_SOURCE', payload: null });
	};

	useEffect(() => {
		if (
		  addSuccessMessage &&
		  data?.status &&
		  API_SUCCESS_CODES.includes(data.status)
		) {
		  setOnSaveCalled(false);
	  
		  setToastMessage(data.msg);
		  setToastType('success');
		  setShowToast(true);
	  
		  // 🔥 Refresh topology data FIRST
		  dispatch(listLiteTopology(null));

		  if (parentGroup?.site_id) {
			dispatch(listGroupBySite(parentGroup.site_id));
		  }
	  
		  onAdd();
	  
		  setTimeout(() => {
			dispatch({ type: ADD_GROUP_RESET_SUCCESS_MSG_OR_ERROR });
			onClose();
		  }, 700);
		}
		if (addErrorMessage) {
			setOnSaveCalled(false);
			const errorMessage = getErrorMsgFromApiResp(addErrorMessage);
			if (errorMessage === 'MAX_SUB_SITE_DEPTH_LEVEL_REACHED') {
				if (!showMaxSiteAlert) {
					setShowMaxSiteAlert(true);
				}
				return;
			}
			setToastMessage(errorMessage);
			// setToastMessage(addErrorMessage.nested_site_name);
			setShowToast(true);
			setToastType('error');
			setTimeout(() => {
				setShowToast(false);
			}, 3000);
			dispatch({ type: ADD_GROUP_RESET_SUCCESS_MSG_OR_ERROR });
			onAdd();
		}
	}, [addSuccessMessage, addErrorMessage, dispatch]);

	return (
		<Box>
			{isAddGroupModalOpen && (
				<FormModal
					isOpen={isAddGroupModalOpen}
					setIsOpen={onClose}
					title={'Add Site'}
					onSave={onSave}
					// disableSave={isSaveDisabled}
					disableSave={isSaveDisabled || onSaveCalled}
					onCancel={onCancel}
					onReset={onReset}
					disableReset={isSaveDisabled}
					onSaveClicked={onSaveCalled}
				>
					{ showMaxSiteAlert && (
						<div style={{ zIndex: 1400, position: 'fixed' }}>
							<Alert
								message={
									'You can only create up to 4 child sites under a parent site.'
								}
								type={'error'}
								title={`Child Sites Limit Reached`}
								primaryButton={'OK'}
								onPrimaryAction={() => setShowMaxSiteAlert(false)}
								onCloseAction={() => setShowMaxSiteAlert(false)}
							/>
						</div>
					)}
					<Grid
						style={{
							position: 'sticky',
							top: 0, // Stick to the top
							zIndex: 100,
							backgroundColor: color.background.primary,
							// padding: '24px', // Add some padding for spacing
						}}
					></Grid>
					<div
						style={
							{
								// paddingLeft: '24px',
								// paddingRight: '24px',
							}
						}
					>
						<Grid
							className="add-group-row-2"
							sx={{ paddingBottom: '30px' }}
						>
							<Grid className="add-group-row-2" width={280}>
								<Tooltip
									content={RootGroupCBTT}
									type="basic"
									direction="bottom"
									offsetX={112}
									delay={300}
									style={{ width: '240px' }}
								>
									<Grid
										sx={{
											display: 'flex',
											flexDirection: 'row',
										}}
									>
										<Grid sx={{ marginTop: '3px' }}>
											<CustomCheckbox
												dataTestId="root_group_checkbox"
												checked={rootGroupCheckbox}
												onChecked={
													updateRootGroupCheckBox
												}
											/>
										</Grid>
										<Typography
											sx={{
												marginLeft: '8px',
												...subtitleFont,
											}}
										>
											Root Site
										</Typography>
									</Grid>
								</Tooltip>
							</Grid>

							<Grid
								className="add-group-row-2"
								style={{ marginLeft: '20px' }}
							>
								<Tooltip
									content={TIPGroupCBTT}
									type="basic"
									direction="bottom"
									delay={300}
									offsetX={112}
									style={{ width: '240px' }}
								>
									<Grid
										sx={{
											display: 'flex',
											flexDirection: 'row',
										}}
									>
										<Grid sx={{ alignSelf: 'center' }}>
											<CustomCheckbox
												dataTestId="tip_group_checkbox"
												checked={tipGroupCheckbox}
												disabled={addGroupSource !== 'sidebar' && siteData?.is_tip_enabled === 1}
												onChecked={
													updateTipGroupCheckBox
												}
											/>
										</Grid>
										<OpenWiFiSiteIcon
											style={{
												width: '74px',
												height: '32px',
												marginLeft: '7px',
											}}
										/>
										{/* <Box
										component="img"
										src={OpenWifiLogo}
										alt="OpenWiFi Logo"
										sx={{
											width: '74px',
											height: '32px',
											flexGrow: 0,
											marginLeft: '8px',
											...subtitleFont, // Additional styles from subtitleFont, if applicable
										}}
									/> */}
									</Grid>
								</Tooltip>
							</Grid>
						</Grid>

						{rootGroupCheckbox && !tipGroupCheckbox && (
							<>
								<Grid className="add-group-row">
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={groupName}
											dataTestId="RootGroupTextField1"
											error={groupNameError}
											label={'Site Name *'}
											id={'Group-Name'}
											width={280}
											onChangeText={handleGroupName}
											maxLength={50}
											// tooltipText={GroupNameTT}
											// tooltipWidth={280}
											required={false}
										/>
									</Grid>

									<Grid className="add-group-row-margin">
										<CustomTextField
											value={location}
											dataTestId="RootGroupTextField3"
											error={locationError}
											label={'Location *'}
											id={'Location'}
											width={280}
											onChangeText={handleLocation}
											tooltipText={LocationTT}
											tooltipWidth={'280px'}
										/>
									</Grid>
									<Grid className="add-group-row-margin">
										{/* <CustomSelectFieldCountry
											selectedItem={country}
											dataTestId="RootGroupSelect2"
											error={countryError}
											label={
												'Regulatory Domain / Country'
											}
											id={'Regulatory-Domain'}
											width={280}
											onChangeText={handleCountry}
											optionItem={regionValue}
											tooltipText={
												RegulatoryDomainCountryTT
											}
											tooltipWidth={'280px'}
											required={true}
											// disabled={true}
										/> */}

										<CustomSelectField
											optionItem={regionValue}
											id={'Regulatory-Domain'}
											// width={'100%'}
											label="Regulatory Domain / Country"
											tooltipText={
												RegulatoryDomainCountryTT
											}
											tooltipWidth={'280px'}
											selectedItem={country}
											error={countryError}
											required={true}
											width={280}
											isSearchOptionRequiredOrNot={true}
											onChangeText={handleCountry}
										/>
									</Grid>
								</Grid>
								<Grid className="add-group-row"></Grid>
								<Grid className="add-group-row" style={{ marginTop: groupNameError ? '24px' : 'inherit' }}>
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={sapId}
											dataTestId="RootGroupTextField2"
											required={true}
											label={sapLabel}
											id={'SAP-ID'}
											width={280}
											onChangeText={handleSapId}
											error={sapIdError}
											tooltipText={`Enter the ${sapLabel} for the associated with this site`}
											tooltipWidth={280}
											maxLength={20}
										/>
									</Grid>
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={description}
											dataTestId="RootGroupTextField4"
											required={false}
											label={'Description'}
											id={'Description'}
											width={280}
											onChangeText={handleDescription}
											// tooltipText={DescriptionTT}
											// tooltipWidth={280}
											error={descriptionError}
											maxLength={255}
										/>
									</Grid>
									<Grid sx={{ width: 280 }}></Grid>
								</Grid>
							</>
						)}

						{tipGroupCheckbox && !rootGroupCheckbox && (
							<>
								<Grid
									className="add-group-row"
									style={{ marginBottom: '10px' }}
								>
									<Grid
										className="add-group-row-margin"
										style={{ marginTop: '-8px' }}
									>
										{hideTooltip ? (
											// <TopologySelect
											// 	isMultiSelect={false}
											// 	onChangeSelection={(
											// 		updatedValues
											// 	) => {
											// 		handleParentGroup(
											// 			updatedValues
											// 		);
											// 		setHideTooltip(false);
											// 		setGroupValue(
											// 			updatedValues
											// 		);
											// 	}}
											// 	label="Parent Site"
											// 	width={280}
											// 	selectedItems={groupValue}
											// 	error={parentGroupError}
											// />
											<TopologySelectWOLazyLoading
												isTip={null}
												isMultiSelect={false}
												onChangeSelection={(
													updatedValues
												) => {
													handleParentGroup(
														updatedValues
													);
													setHideTooltip(false);
													setGroupValue(
														updatedValues
													);
												}}
												label="Parent Site"
												width={280}
												selectedItems={groupValue}
												error={parentGroupError}
											/>
										) : (
											<Tooltip
												content={ParentSiteTT}
												type="basic"
												direction="top"
												delay={300}
												style={{ width: '280px' }}
											>
												{/* <TopologySelect
													isMultiSelect={false}
													onChangeSelection={(
														updatedValues
													) => {
														handleParentGroup(
															updatedValues
														);
														setHideTooltip(true);
														setGroupValue(
															updatedValues
														);
													}}
													label="Parent Site"
													width={280}
													selectedItems={groupValue}
													error={parentGroupError}
												/> */}
												<TopologySelectWOLazyLoading
													isTip={null}
													isMultiSelect={false}
													onChangeSelection={(
														updatedValues
													) => {
														handleParentGroup(
															updatedValues
														);
														setHideTooltip(true);
														setGroupValue(
															updatedValues
														);
													}}
													label="Parent Site"
													width={280}
													selectedItems={groupValue}
													error={parentGroupError}
													onDropdownStateChange={(
														isOpen
													) => {
														setHideTooltip(isOpen); // Hide tooltip when dropdown is open
													}}
												/>
											</Tooltip>
										)}
									</Grid>
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={groupName}
											dataTestId="RootGroupTextField1"
											error={groupNameError}
											label={'Site Name *'}
											id={'Group-Name'}
											width={280}
											maxLength={50}
											onChangeText={handleGroupName}
											// tooltipText={GroupNameTT}
											tooltipWidth={280}
											required={false}
										/>
									</Grid>
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={location}
											dataTestId="RootGroupTextField3"
											error={locationError}
											label={'Location *'}
											id={'Location'}
											width={280}
											onChangeText={handleLocation}
											tooltipText={LocationTT}
											tooltipWidth={280}
											required={false}
										/>
									</Grid>
								</Grid>
								<Grid className="add-group-row">
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={sapId}
											dataTestId="RootGroupTextField2"
											required={true}
											label={sapLabel}
											id={'SAP-ID'}
											width={280}
											onChangeText={handleSapId}
											error={sapIdError}
											tooltipText={`Enter the ${sapLabel} for the associated with this site`}
											tooltipWidth={280}
											maxLength={20}
										/>
									</Grid>
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={description}
											dataTestId="RootGroupTextField4"
											required={false}
											label={'Description'}
											id={'Description'}
											width={280}
											onChangeText={handleDescription}
											// tooltipText={DescriptionTT}
											// tooltipWidth={280}
											error={descriptionError}
											maxLength={255}
										/>
									</Grid>
									<Grid sx={{ width: 280 }}></Grid>
								</Grid>
							</>
						)}
						{tipGroupCheckbox && rootGroupCheckbox && (
							<>
								<Grid className="add-group-row">
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={groupName}
											dataTestId="RootGroupTextField1"
											error={groupNameError}
											label={'Site Name *'}
											id={'Group-Name'}
											width={280}
											maxLength={50}
											onChangeText={handleGroupName}
											// tooltipText={GroupNameTT}
											// tooltipWidth={280}
											required={false}
										/>
									</Grid>
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={location}
											dataTestId="RootGroupTextField3"
											error={locationError}
											label={'Location *'}
											id={'Location'}
											width={280}
											onChangeText={handleLocation}
											tooltipText={LocationTT}
											tooltipWidth={280}
											required={false}
										/>
									</Grid>
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={sapId}
											dataTestId="RootGroupTextField2"
											required={true}
											label={'sapLabel'}
											id={'SAP-ID'}
											width={280}
											onChangeText={handleSapId}
											error={sapIdError}
											tooltipText={`Enter the ${sapLabel} for the associated with this site`}
											tooltipWidth={280}
											maxLength={20}
										/>
									</Grid>
								</Grid>
								<Grid className="add-group-row">
									{/* <Grid className = 'add-group-row-margin'><CustomTextField value={location} dataTestId='RootGroupTextField3' error={locationError} label = {'Location'} id = {'Location'} width = {280} onChangeText = {handleLocation} /></Grid> */}
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={description}
											dataTestId="RootGroupTextField4"
											required={false}
											label={'Description'}
											id={'Description'}
											width={280}
											onChangeText={handleDescription}
											// tooltipText={DescriptionTT}
											// tooltipWidth={280}
											error={descriptionError}
											maxLength={255}
										/>
									</Grid>
								</Grid>
							</>
						)}
						{!tipGroupCheckbox && !rootGroupCheckbox && (
							<>
								<Grid
									className="add-group-row"
									style={{ marginBottom: '10px' }}
								>
									<Grid
										className="add-group-row-margin"
										style={{ marginTop: '-8px' }}
									>
										{/* <CustomTreeSelectField
											value={[parentGroupName]}
											dataTestId="RootGroupSelect1"
											error={parentGroupError}
											label={'Parent Site'}
											id={'Parent-Group'}
											width={280}
											onNodeSelect={handleParentGroup}
											treeData={group?.results || []}
											required={false}
										/> */}
										{hideTooltip ? (
											// <TopologySelect
											// 	isMultiSelect={false}
											// 	onChangeSelection={(
											// 		updatedValues
											// 	) => {
											// 		handleParentGroup(
											// 			updatedValues
											// 		);
											// 		setGroupValue(
											// 			updatedValues
											// 		);
											// 		setHideTooltip(false);
											// 	}}
											// 	label="Parent Site"
											// 	width={280}
											// 	selectedItems={groupValue}
											// 	error={parentGroupError}
											// />
											<TopologySelectWOLazyLoading
												isTip={null}
												isMultiSelect={false}
												onChangeSelection={(
													updatedValues
												) => {
													handleParentGroup(
														updatedValues
													);
													setGroupValue(
														updatedValues
													);
													setHideTooltip(false);
												}}
												label="Parent Site"
												width={280}
												selectedItems={groupValue}
												error={parentGroupError}
											// onDropdownStateChange={(isOpen) => {
											// 	setHideTooltip(isOpen); // Hide tooltip when dropdown is open
											//   }}
											/>
										) : (
											<Tooltip
												content={ParentSiteTT}
												type="basic"
												direction="top"
												delay={300}
												style={{ width: '280px' }}
											>
												{/* <TopologySelect
													isMultiSelect={false}
													onChangeSelection={(
														updatedValues
													) => {
														handleParentGroup(
															updatedValues
														);
														setHideTooltip(true);
														setGroupValue(
															updatedValues
														);
													}}
													label="Parent Site"
													width={280}
													selectedItems={groupValue}
													error={parentGroupError}
												/> */}
												<TopologySelectWOLazyLoading
													isTip={null}
													isMultiSelect={false}
													onChangeSelection={(
														updatedValues
													) => {
														handleParentGroup(
															updatedValues
														);
														setHideTooltip(true);
														setGroupValue(
															updatedValues
														);
													}}
													label="Parent Site"
													width={280}
													selectedItems={groupValue}
													error={parentGroupError}
													onDropdownStateChange={(
														isOpen
													) => {
														setHideTooltip(isOpen); // Hide tooltip when dropdown is open
													}}
												/>
											</Tooltip>
										)}
									</Grid>
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={groupName}
											dataTestId="RootGroupTextField1"
											error={groupNameError}
											label={'Site Name *'}
											id={'Group-Name'}
											width={280}
											maxLength={50}
											onChangeText={handleGroupName}
											// tooltipText={GroupNameTT}
											// tooltipWidth={280}
											required={false}
										/>
									</Grid>
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={location}
											dataTestId="RootGroupTextField3"
											error={locationError}
											label={'Location *'}
											id={'Location'}
											width={280}
											onChangeText={handleLocation}
											tooltipText={LocationTT}
											tooltipWidth={280}
											required={false}
										/>
									</Grid>
								</Grid>
								<Grid className="add-group-row">
									<Grid
										className="add-group-row-margin"
										style={{ marginTop: '-7px' }}
									>
										{/* <CustomSelectFieldCountry
											selectedItem={country}
											dataTestId="RootGroupSelect2"
											error={countryError}
											label={'Regulatory Domain / Country'}
											id={'Regulatory-Domain'}
											width={280}
											onChangeText={handleCountry}
											optionItem={regionValue}
											tooltipText={RegulatoryDomainCountryTT}
											tooltipWidth={280}
											required={true}
										/> */}

										<CustomSelectField
											optionItem={regionValue}
											id={'Regulatory-Domain'}
											// width={'100%'}
											label="Regulatory Domain / Country"
											tooltipText={
												RegulatoryDomainCountryTT
											}
											tooltipWidth={'280px'}
											selectedItem={typeof country === 'string' ? country : country?.code}
											error={countryError}
											required={true}
											width={280}
											onChangeText={handleCountry}
											isSearchOptionRequiredOrNot={true}
										/>
									</Grid>
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={sapId}
											dataTestId="RootGroupTextField2"
											required={true}
											label={sapLabel}
											id={'SAP-ID'}
											width={280}
											onChangeText={handleSapId}
											error={sapIdError}
											tooltipText={`Enter the ${sapLabel} for the associated with this site`}
											tooltipWidth={280}
											maxLength={20}
										/>
									</Grid>
									<Grid className="add-group-row-margin">
										<CustomTextField
											value={description}
											dataTestId="RootGroupTextField4"
											required={false}
											label={'Description'}
											id={'Description'}
											width={280}
											onChangeText={handleDescription}
											// tooltipText={DescriptionTT}
											// tooltipWidth={280}
											error={descriptionError}
											maxLength={255}
										/>
									</Grid>
									{/* <Grid width={280}></Grid> */}
								</Grid>
							</>
						)}
					</div>
				</FormModal>
			)}
			{/* Render the Toast component based on the visibility state */}
			{showToast && (
				<Toast
					message={toastMessage}
					isVisible={true}
					messageType={toastType}
					onCancel={onCancelToast}
				/>
			)}
			{/* Render the Toast component based on the visibility state
			{error && (
				<Toast
					messageType="error"
					isVisible={error !== null ? true : false}
					showCloseButton={false}
					message={error}
					onCancel={onCancelToast}
				/>
			)} */}
		</Box>
	);
};
AddGroup.propTypes = {
	onAdd: PropTypes.func.isRequired,
	selectedNode: PropTypes.object,
	tableLoc: PropTypes.string,
};

export default AddGroup;
